export interface NZDocumentInfo {
  id?: string;
  _id?: string;
  slug?: string;
  parentId?: string;
  type: NZDocumentType;
  fileHash: string;
  mimeType: string;
  expirationDate?: Date;
  status?: NZDocumentStatus;
  displayName?: string;
  description?: string;
  createdAt?: Date;
  updatedAt?: Date;
  createdBy?: string;
  content?: string;
  projectId?: string;
  serialNumber?: string;
}

export enum NZDocumentType {
  GENERAL_PURPOSE = 'GENERAL_PURPOSE',
  OTHER = 'OTHER',
  QUESTION_IMAGE = 'QUESTION_IMAGE',
  DRAFT_EXAM = 'DRAFT_EXAM',
  EXAM_POOL = 'EXAM_POOL',
  CANDIDATE_DIAGNOSIS = 'CANDIDATE_DIAGNOSIS',
  MARKER_REPORT = 'MARKER_REPORT',
  EXAM_RESOURCE = 'EXAM_RESOURCE',
  EXAM_SCHEDULE = 'EXAM_SCHEDULE',
}

export enum NZDocumentStatus {
  REVOKED = 'REVOKED',
  ACTIVE = 'ACTIVE',
  PENDING = 'PENDING'
}

class NZDocument {
  id?: string;
  slug?: string;
  createdBy?: string;
  parentId?: string;
  type: NZDocumentType;
  fileHash: string;
  mimeType: string;
  expirationDate?: Date;
  status?: NZDocumentStatus;
  displayName?: string;
  description?: string;
  createdAt?: Date;
  updatedAt?: Date;
  content?: string;
  projectId?: string;
  serialNumber?: string;

  constructor(file: NZDocumentInfo) {
    this.id = file.id ? file.id : file._id;
    this.slug = file.slug;
    this.parentId = file.parentId;
    this.type = file.type;
    this.fileHash = file.fileHash;
    this.mimeType = file.mimeType;
    this.expirationDate = file.expirationDate;
    this.status = file.status;
    this.displayName = file.displayName;
    this.description = file.description;
    this.createdAt = file.createdAt;
    this.createdBy = file.createdBy;
    this.updatedAt = file.updatedAt;
    this.content = file.content;
    this.projectId = file.projectId;
    this.serialNumber = file.serialNumber;
  }

  load(data: any): NZDocument {
    return new NZDocument(data);
  }

  toObject(): NZDocumentInfo {
    return {
      id: this.id,
      slug: this.slug,
      parentId: this.parentId,
      type: this.type,
      fileHash: this.fileHash,
      mimeType: this.mimeType,
      expirationDate: this.expirationDate,
      status: this.status,
      displayName: this.displayName,
      description: this.description,
      createdBy: this.createdBy,
      createdAt: this.createdAt,
      content: this.content,
      projectId: this.projectId,
      serialNumber: this.serialNumber,
    };
  }
}

export default NZDocument;
